module.exports = __webpack_public_path__ + "img/cuttingBoardBackgroundNew.6246f57c.jpg";